import { certificateSlice } from "./store/certificate.slice";
import {
  certificateApi,
  useGetCertificatesQuery,
  useCreateCertificateMutation,
  useUpdateCertificateMutation,
  useLazyGetCertificateByIdQuery,
  useLazyGetCertificatesQuery,
  useDeleteCertificateMutation,
  useReorderCertificatesMutation,
} from "./api/certificate.api";

export const { setCertificates } = certificateSlice.actions;

export {
  certificateApi,
  certificateSlice,
  useReorderCertificatesMutation,
  useGetCertificatesQuery,
  useCreateCertificateMutation,
  useUpdateCertificateMutation,
  useLazyGetCertificateByIdQuery,
  useLazyGetCertificatesQuery,
  useDeleteCertificateMutation
};
